module.exports = __webpack_public_path__ + "static/media/icon_syokumu.5e6ddf9a.svg";